import DateFnsUtils from '@date-io/date-fns';
import lime from '@material-ui/core/colors/lime';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import * as React from 'react';
import { useMiaSelector } from './components/hooks';
import { LoginPage } from './components/LoginPage';
import { MainPage } from './layout/MainPage';
import { SplashPage } from './layout/SplashPage';

const theme = createMuiTheme({
  overrides: {
    MuiTableCell: { root: { padding: 8 } }
  },
  palette: {
    primary: {
      dark: '#000631',
      light: '#3b5988',
      main: '#00305B'
    },
    secondary: { main: lime.A700 }
  }
});

interface IRootProps {}

let Root: React.FunctionComponent<IRootProps> = () => {
  const appInitialized = useMiaSelector(state => state.core.appInitialized);
  const loggedIn = useMiaSelector(state => state.auth.loggedIn);
  const showSplashPage = useMiaSelector(state => state.ui.showSplashPage);

  const view = React.useMemo(() => {
    if (showSplashPage && !appInitialized) {
      return <SplashPage />;
    } else if (loggedIn && appInitialized) {
      return <MainPage />;
    } else {
      return <LoginPage />;
    }
  }, [appInitialized, loggedIn, showSplashPage]);
  return (
    <CssBaseline>
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>{view}</MuiPickersUtilsProvider>
      </ThemeProvider>
    </CssBaseline>
  );
};

Root = React.memo<IRootProps>(Root);
export { Root };
